import httpMethod from 'services/update2025/httpMethod';
import BlockDetail from "components/block-detail/BlockDetail";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { Toast } from "primereact/toast";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { PersonInfoContext } from "./PersonInfoContext";

export const PersonInfoHistory = () => {
    const toast = useRef(null);
    const dt1 = useRef(null);
    const dt2 = useRef(null);

    const { t, i18n } = useTranslation(["person-info", "common"]);
    const tokenObj = httpMethod.getTokenStorage(); // { access_token, … }
    const accessToken = tokenObj?.access_token;;

    const dependentHistoryContext = useContext(PersonInfoContext);
    const { infoHistoryCards, setInfoHistoryCards, infoHistoryPersons, setInfoHistoryPersons, changeType, setChangeType, setPersonInfoHistoryDialog, personInfoHistoryDialog } = dependentHistoryContext;

    const [title, setTitle] = useState(null);

    let headers = {
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": i18n.language,
    };

    const sources = [
        { label: "Dân cư", value: "DC" },
        { label: "Định danh điện tử", value: "DDDT" },
        { label: "Căn cước công dân", value: "CCCD" }
    ];

    useEffect(() => {
        if (changeType === 1) {
            setTitle(t("person.historyChangeInfo").toUpperCase());
        } else if (changeType === 4) {
            setTitle(t("person.historyChangeCCCD").toUpperCase());
        }
    }, [changeType]);

    const updateSourceTemplateBody = (rowData) => {
        return <div className="flex align-items-left justify-content-left">{sources.find((e) => (e.value == rowData.updatedSource))?.label}</div>;
    };

    const peopelChangeTemplateBody = (rowData) => {
        return <div className="flex align-items-left justify-content-left">{sources.find((e) => (e.value == rowData.peopleChange))?.label}</div>;
    };

    const paginatorTemplate = {
        layout: "RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink",
        RowsPerPageDropdown: (options) => {
            const dropdownOptions = [
                { label: 10, value: 10 },
                { label: 20, value: 20 },
                { label: 30, value: 30 },
                { label: 50, value: 50 },
            ];

            return (
                <React.Fragment>
                    <div style={{ width: "140px", display: "contents" }}>
                        <span className="mx-1">{t("show", { ns: "common" })}: </span>
                        <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
                    </div>
                </React.Fragment>
            );
        },
        CurrentPageReport: (options) => {
            return <span style={{ width: "calc(100% - 490px)", textAlign: "center", display: "inline-block" }}>{t("total", { ns: "common", total: options.totalRecords })}</span>;
        },
    };

    const getHistory = () => {
        if (changeType === 1) {
            return (
                <BlockDetail title={t("person.historyChangeInfo")}>
                    <DataTable
                        ref={dt1}
                        value={infoHistoryPersons}
                        dataKey="stt"
                        className="datatable-responsive p-datatable-sm"
                        showGridlines
                        emptyMessage="Không có dữ liệu"
                        rows={10}
                        first={0}
                        paginator
                        paginatorClassName="justify-content-start"
                        paginatorTemplate={paginatorTemplate}
                        totalRecords={infoHistoryPersons.length}
                    >
                        <Column field="stt" header={t("stt", { ns: "common" })} />
                        <Column field="idNumber" header={t("person.idNumber")} />
                        <Column field="field" header={t("person.field")} />
                        <Column field="valueBefore" header={t("person.valueBefore")} />
                        <Column field="valueAfter" header={t("person.valueAfter")} />
                        <Column field="changeDate" header={t("person.changeDate")} />
                        <Column field="updatedSource" header={t("person.updatedSource")} body={updateSourceTemplateBody} />
                        <Column field="peopleChange" header={t("person.peopleChange")} body={peopelChangeTemplateBody} />
                    </DataTable>
                </BlockDetail>
            );
        } else if (changeType === 4) {
            return (
                <BlockDetail title={t("person.historyChangeInfos")}>
                    <DataTable
                        ref={dt2}
                        value={infoHistoryCards}
                        dataKey="stt"
                        className="datatable-responsive p-datatable-sm"
                        showGridlines
                        emptyMessage="Không có dữ liệu"
                        rows={10}
                        first={0}
                        paginator
                        paginatorClassName="justify-content-start"
                        paginatorTemplate={paginatorTemplate}
                        totalRecords={infoHistoryPersons.length}
                    >
                        <Column field="stt" header={t("stt", { ns: "common" })} />
                        <Column field="idNumber" header={t("person.idNumber")} />
                        <Column field="field" header={t("person.field")} />
                        <Column field="valueBefore" header={t("person.valueBefore")} />
                        <Column field="valueAfter" header={t("person.valueAfter")} />
                        <Column field="changeDate" header={t("person.changeDate")} />
                        <Column field="updatedSource" header={t("person.updatedSource")} body={updateSourceTemplateBody} />
                        <Column field="peopleChange" header={t("person.peopleChange")} body={peopelChangeTemplateBody} />
                    </DataTable>
                </BlockDetail>
            );
        }
        return <></>;
    };

    const hideDialog = () => {
        setPersonInfoHistoryDialog(false);
        setChangeType(null);
    };

    return (
        <>
            <Toast ref={toast} />
            <Dialog visible={personInfoHistoryDialog} style={{ width: "70%" }} header={title} modal className="p-fluid text-center" onHide={hideDialog}>
                <div className="formgrid">
                    <div className="grid mt-2">
                        <div className="col-12">{getHistory()}</div>
                    </div>
                </div>
                <div className="grid">
                    <div className="col-12">
                        <Button
                            style={{
                                width: "max-content",
                            }}
                            label={t("close", { ns: "common" })}
                            icon="pi pi-times"
                            onClick={hideDialog}
                        />
                    </div>
                </div>
            </Dialog>
        </>
    );
};
